import React from "react";

const OrgUsage = ({ orgId }) => {
  return (
    <iframe
      title="Usage"
      src={`https://analytics.zoho.eu/open-view/276819000000009928?ZOHO_CRITERIA=%22Organizzazione%22.%22_id%22%3D'${orgId}'`}
      style={{
        height: "100vh",
        width: "100%",
        border: "none",
      }}
      height="100%"
      width="100%"
    />
  );
};

export default OrgUsage; 